import * as React from 'react';
import {Link as ReactLink} from 'react-router-dom';

interface Props {
  to?: string;
  children: React.ReactElement;
  onClick?: (e: React.SyntheticEvent) => void;
  disabled?: boolean;
  className?: string;
  style?: {
    [key: string]: any;
  }
}

const Link: React.FC<Props> = ({
  to,
  children,
  onClick,
  className,
  disabled = false,
  style,
}) => {
  const onClickHandler: (e: React.SyntheticEvent) => void = (e) => {
    if (disabled) e.preventDefault();

    if (onClick) onClick(e);
  };

  const props = {
    to: {pathname: to},
    target: null
  };

  if (to?.startsWith('http')) props.target = '_blank';

  return to ? (
    <ReactLink
      onClick={onClickHandler}
      {...props}
      style={style}
      className={className}
    >
      {children}
    </ReactLink>
  ) : (
    <a
      href={"#"}
      onClick={onClickHandler}
      style={style}
      className={className}
    >
      {children}
    </a>
  )
}

export default Link;
